import { useState, useEffect } from 'react';

export const loadFromStorage = (key, defaultValue = null) => {
  try {
    const stored = localStorage.getItem(key);
    return stored !== null ? JSON.parse(stored) : defaultValue;
  } catch {
    return defaultValue;
  }
};

export const saveToStorage = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Quota exceeded or storage unavailable — fail silently
  }
};

export const clearStorage = (key) => {
  try {
    localStorage.removeItem(key);
  } catch {
    // fail silently
  }
};

// Hook for functional components (e.g. WeatherObsExercises if converted)
export const useLocalStorage = (key, initialValue) => {
  const [value, setValue] = useState(() => loadFromStorage(key, initialValue));

  useEffect(() => {
    saveToStorage(key, value);
  }, [key, value]);

  const clear = () => {
    clearStorage(key);
    setValue(initialValue);
  };

  return [value, setValue, clear];
};
